import PopupResultFormComponent from '../../form/js/popup-result-form.component';
import createEvent from '../../../general/js/create-event';

export default class OfferFormComponent extends PopupResultFormComponent {
    constructor() {
        super(...arguments);

        this.checkbox = this.refs.checkbox;
        this.initCheckbox();
    }

    static getRequiredRefs() {
        return ['checkbox'];
    }

    initCheckbox(){
        if(typeof this.checkbox != 'undefined'){
            this.checkbox.addEventListener('change', () => {
                if(this.checkbox.checked){
                    this.element.querySelector('button').classList.remove('is-disabled');
                }else{
                    this.element.querySelector('button').classList.add('is-disabled');
                }
            });
        }
    }

    onAfterReset(){
        this.checkbox.dispatchEvent(createEvent('change'));
    }
}



// WEBPACK FOOTER //
// ./app/components/offer/js/offer-form.component.js